<template>
<div>
  <a-input-search placeholder="search" @search="onSearch"  style="float:left;width:30%;margin:5px" />
  <a-button icon="user-add" @click="onCreateClicked"  type="primary" style="margin:5px">新規</a-button>
  <a-table :loading="isLoading" :columns="columns" :dataSource="data" size="small" :pagination="false" expandRowByClick :expandIconAsCell="false" :expandIconColumnIndex="-1">
    <!-- <a-table slot="expandedRowRender" slot-scope="text" :columns="innerColumns" :dataSource="innerData" :pagination="false" /> -->
    <div slot="permissions" slot-scope="permissions">
      <a-tag color="red" icon="lock" v-if="permissions.length>0">
        <a-icon type="lock" /></a-tag>
      <a-tag icon="info" v-else>
        <a-icon type="info" /></a-tag>
    </div>
    <div slot="expandedRowRender" slot-scope="record" style="margin: 0px;padding:0px">
      <!-- <a-button @click="onEditClicked(record.employee)" size="small">edit</a-button> -->
      <InfoCard :employee="record.employee"></InfoCard>
    </div>
    <div slot="actions" slot-scope="text, record" style="margin: 0">
      <a-popover title="該当社員を削除しますか？" trigger="click" v-model="record.confirmpopvisible">
        <div slot="content">
          <a-button size="small" @click="onDeleteConfirmClicked(record)" type="danger" style="margin-left:5px">OK</a-button>
        </div>
      <a-button size="small" :disabled="record.disable">退職</a-button>
      </a-popover>
    </div>
  </a-table>
</div>
</template>
<script>
import InfoCard from "@/components/apps/InfoCard.vue";
const columns = [{
    title: 'EID',
    dataIndex: 'eid',
    key: 'eid'
  },
  {
    title: '名前',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '入社日',
    dataIndex: 'joined_at',
    key: 'joined_at'
  },
  {
    title: '権限',
    dataIndex: 'permissions',
    key: 'permissions',
    scopedSlots: {
      customRender: 'permissions'
    }
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: {
      customRender: 'actions'
    }
  }
];
export default {
  name: "employeelist",
  components: {
    InfoCard
  },
  created() {
    this.loadData()
  },
  computed: {
    data: {
      get: function() {
        this.tableData.sort((a,b)=>{
          return a.eid-b.eid
        })
        
        if (this.filterword) {
          return this.tableData.filter(d => d.eid.indexOf(this.filterword) !== -1 || d.name.indexOf(this.filterword) !== -1);
        } else {
          return this.tableData
        }
      }
    },
  },
  data() {
    return {
      isLoading: true,
      filterword: "",
      tableData: [],
      columns
    }
  },
  methods: {
    loadData() {
      this.isLoading = true
      let token = this.$store.getters.token;
      this.$api.employee.queryAll({
        token: token
      }).then(data => {
        let resp = data.data;
        this.isLoading = false;
        this.$logger.d("EmployeeList", "loadData.queryAll", {
          response: resp
        });
        if (resp.error) {
          // this.$notification.error({
          //   message: "エラー:" + resp.error.code,
          //   description: resp.error.description
          // });
          // this.$router.push({
          //   path: "/"
          // });
          this.$error_handler(this,resp.error)
        } else {
          this.tableData = []

          resp.result.employees.forEach((emp, i) => {
            this.tableData.push({
              key: i,
              eid: emp.eid,
              name: emp.user.userinfo.lastname + " " + emp.user.userinfo.firstname,
              joined_at: emp.joined_at,
              telphone: emp.user.userinfo.telphone,
              permissions: [],
              employee: emp
            })
          })
        }
      }).catch(err => {
        this.$logger.e("EmployeeList", "loadData.queryAll", {
          error: err
        });
        this.$notification.error({
          message: "エラー",
          description: "サーバ通信エラー"
        });
        this.$router.push({
          path: "/"
        });
      });
    },
    onSearch(value) {
      this.filterword = value
    },
    onEditClicked(emp) {
      console.log(JSON.stringify(emp));
    },
    onCreateClicked() {
      console.log("onCreateClicked");
      
      this.$router.push({path:"/create_employee"})
    },
    onDeleteConfirmClicked(record) {
      console.log("onDeleteConfirmClicked");
      this.$api.employee.delete({
        eid: record.employee.eid,
        token: this.$store.getters.token
      });//todo then
      this.loadData();
    }
  }
}
</script>
